import { cn } from '@/lib/tailwind-utils.js';
import {
  CoachPaymentDepositInfoStatus,
  coachPaymentDepositInfoStatusSchema,
  CoachPaymentDepositInfoStatusToLabel,
} from '@airreading/common/data';

type DepositInfoStatusProps = {
  depositInfoStatus: CoachPaymentDepositInfoStatus;
};

export const DepositInfoStatus = (props: DepositInfoStatusProps) => {
  const { depositInfoStatus } = props;

  const isPaymentConnected = depositInfoStatus === coachPaymentDepositInfoStatusSchema.enum.ready;

  return (
    <div
      className={cn('text-orange-600 flex items-center gap-2', {
        'text-lime-600': isPaymentConnected,
      })}
    >
      <span className="w-2 h-2 rounded-full bg-current block" />
      <span>{CoachPaymentDepositInfoStatusToLabel[depositInfoStatus]}</span>
    </div>
  );
};
